import React from "react";

const SvgComponent = props => (
  <svg viewBox="0 0 2048 2048" width="1em" height="1em" {...props}>
    <path
      className="OfficeIconColors_HighContrast"
      d="M410 410H102V102h308m0 717v307H102V819m308 717v307H102v-307m1844-512H717V922h1229m0-717v102H717V205m1229 1433v103H717v-103z"
    />
    <path
      className="OfficeIconColors_m24"
      d="M410 410H102V102h308m0 717v307H102V819m308 717v307H102v-307z"
    />
    <path
      className="OfficeIconColors_m22"
      d="M1946 1024H717V922h1229m0-717v102H717V205m1229 1433v103H717v-103z"
    />
  </svg>
);

export default SvgComponent;
